<script setup lang="ts">
import { getLocaleDescription } from '~~/models/Locale';

const { locale: currentLocaleCode, locales, setLocale } = useI18n();

const items = computed(() => locales.value.map((locale) => locale.code));
</script>

<template>
	<USelect
		v-model="currentLocaleCode"
		selected-icon="i-lucide-check"
		:icon="undefined"
		:items="items"
		:ui="{
			base: 'uppercase cursor-pointer!',
			content: 'w-full'
		}"
		:content="{ align: 'end' }"
		:trailing-icon="undefined"
		@update:model-value="(value) => setLocale(value)"
	>
		<div class="leading-0">
			<UIcon
				name="i-lucide-globe"
				class="text-2xl text-muted"
			/>
		</div>
		<template #item="{ item: locale }">
			<div
				class="uppercase font-semibold text-xs flex gap-1"
				:class="{
					'text-primary-400': currentLocaleCode === locale,
				}"
			>
				<span>{{ getLocaleDescription(locale) }}</span>
				<span>({{ locale }})</span>
			</div>
		</template>
	</USelect>
</template>
